<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00109" title="[127]"><a id="Page_127"></a></span></p>
<h2 id="RE-CAPTURED">RE-CAPTURED.</h2>
</div>
<div class="blockquot">
<p class="calibre3">HOME GUARDS GOBBLE ME UP—WELL TREATED AND WELL FED—TAKEN
TO DOCTORTOWN AND FROM THENCE TO BLACKSHEAR—THE
TWO BUCK BOYS AS RUNAWAYS—RIDE ON A PASSENGER TRAIN—PROSPECTS
AHEAD, ETC.</p>
</div>
<p class="calibre3"><span class="smcap">Doctortown Station, No. 5</span>, Nov. 30.—Ha! Ha! My boy, you
are a prisoner of war again. Once more with a blasted rebel standing
guard over me, and it all happened in this wise: Just before
dark I went up to that house I spoke of in my writings yesterday.
Walked boldly up and rapped at the door; and what was my complete
astonishment when a white woman answered my rapping.
Asked me what I wanted, and I told her something to eat. Told
me to come in and set down. She was a dark looking woman and
could easily be mistaken from my hiding place of the day for a
negro. Began asking me questions. Told her I was a rebel soldier,
had been in the hospital sick and was trying to reach home in
the adjoining county. Was very talkative; told how her husband
had been killed at Atlanta, &amp;c. She would go out and in from a
shanty kitchen in her preparation of my supper. I looked out
through a window and saw a little darky riding away from the
house, a few minutes after I went inside. Thought I had walked
into a trap, and was very uneasy. Still the woman talked and
worked, and I talked, telling as smoothe lies as I knew how. For
a full hour and a half sat there, and she all the time getting supper.
Made up my mind that I was the same as captured, and so put on
a bold face and made the best of it. Was very well satisfied with<span class="x-ebookmaker-pageno" title="[128]"><a id="Page_128"></a></span>
my escapade anyway, if I could only get a whack at that supper
before the circus commenced. Well, after a while heard some
hounds coming through the woods and towards the house. Looked
at the woman and her face pleaded guilty, just as if she had done
something very mean. The back door of the house was open and
pretty soon half a dozen large blood hounds bounded into the room
and began snuffing me over; about this time the woman began to
cry. Told her I understood the whole thing and she need not make
a scene over it. Said she knew I was a yankee and had sent for
some men at Doctortown. Then five horsemen surrounded the
house, dismounted and four of them came in with guns cocked
prepared for a desperate encounter. I said: “good evening, gentlemen.”
“Good evening,” said the foremost, “we are looking for
a runaway yankee prowling around here.” “Well,” says I, “you
needn’t look any farther, you have found him.” “Yes, I see,”
was the answer. They all sat down, and just then the woman said
“supper is ready and to draw nigh.” Drawed as nigh as I could
to that supper and proceeded to take vengeance on the woman.
The fellows proved to be home guards stationed here at Doctortown.
The woman had mounted the negro boy on a horse just as soon as
I made my appearance at the house and sent for them. They
proved to be good fellows. Talked there at the house a full hour
on the fortunes of war, &amp;c. Told them of my long imprisonment
and escape and all about myself. After a while we got ready to
start for this place. One rebel rode in front, one on each side and
two in the rear of me. Was informed that if I tried to run they
would shoot me. Told them no danger of my running, as I could
hardly walk. They soon saw that such was the case after going a
little way, and sent back one of the men to borrow the woman’s
horse. Was put on the animal’s back and we reached Doctortown
not far from midnight. As we were leaving the house the woman
gave me a bundle; said in it was a shirt and stockings. Told her
she had injured me enough and I would take them. No false delicy
will prevent my taking a shirt. And so my adventure has ended
and have enjoyed it hugely. Had plenty to eat with the exception
of the two days, and at the last had a horseback ride. How well I
was reminded of my last ride when first taken prisoner and at the
time I got the coverlid. In the bundle was a good white shirt, pair
of stockings, and a chunk of dried beef of two pounds or so.
One of the captors gave me ten dollars in Confederate money.
Now am in an old vacant building and guarded and it is the middle<span class="x-ebookmaker-pageno" title="[129]"><a id="Page_129"></a></span>
of the afternoon. Many citizens have visited me and I tell the
guard he ought to charge admission; money in it. Some of the
callers bring food and are allowed to give it to me, and am stocked
with more than can conveniently carry. Have had a good wash
up, put on my clean white shirt with standing collar, and new
stockings and am happy. Doctortown is a small village with probably
six or eight hundred population, and nigger young ones by
the scores. Am treated kindly and well, and judge from conversations
that I hear, that the battles are very disastrous to the rebels
and that the war is pretty well over. All the negroes are hard
pressed, fortifying every available point to contest the advance of
the Union Army. This is cheering news to me. My escape has
given me confidence in myself, and I shall try it again the first
opportunity. A woman has just given me a bottle of milk and
two dollars in money. Thanked her with my heart in my mouth.
Having been captured and brought to this place, am here waiting
for them to get instructions as to what they shall do with me.
They say I will probably be sent to the prison at Blackshear, which
is forty or fifty miles away. Think I should be content to stay
here with plenty to eat. Am in a good clean room in a dwelling.
Can talk with any one who chooses to come and see me. The
room was locked during the night, and this morning was thrown
open, and I can wander through three rooms. Guard is off a few
rods where he can see all around the house. Occasionally I go out
doors and am having a good time. <span class="smcap">Later.</span>—Have seen a Savannah
paper which says Sherman and his hosts are marching toward that
city, and for the citizens to rally to repel the invader. My swollen
ankle is being rubbed to-day with ointment furnished by an old
darky. I tell you there are humane people the world over, who will
not see even an enemy suffer if they can help it. While I have seen
some of the worst people in the South, I have also seen some of
the very best, and those, too, who were purely southern people and
rebels. There are many pleasant associations connected with my
prison life, as well as some directly to the opposite.</p>
<p class="calibre3">Dec. 1.—Still at Doctortown, and the town is doctoring me up
“right smart.” There is also a joke to this, but a weak one. The
whole town are exercised over the coming of the Yankee army,
and I laugh in my sleeve. Once in a while some poor ignorant and
bigoted fellow amuses himself cursing me and the whole U. S.
army. Don’t talk back much, having too much regard for my<span class="x-ebookmaker-pageno" id="pgepubid00110" title="[130]"><a id="Page_130"></a></span>
bodily comfort. Orders have come to put me on a train for Blackshear.
Have made quite a number of friends here, who slyly talk
to me encouragingly. There are many Union people all through
the South, although they have not dared to express themselves as
such, but now they are more decided in their expressions and
actions. Had a canteen of milk, and many other luxuries. Darkys
are profuse in their gifts of small things. Have now a comb, good
jack knife, and many little nicknacks. One old negress brought
me a chicken nicely roasted. Think of that, prisoners of war, roast
chicken! Shall jump off the cars every twenty rods hereafter.
Tried to get a paper of the guard, who was reading the latest, but
he wouldn’t let me see it. Looks rather blue himself, and I surmise
there is something in it which he don’t like. All right, old
fellow, my turn will come some day. Young darky brought me
a cane, which is an improvement on my old one. Walk now the
length of my limit with an old fashioned crook cane and feel quite
proud. <span class="smcap">Later.</span>—Got all ready to take a train due at 3:30, and it
didn’t stop. Must wait until morning. Hope they won’t stop for
a month.</p>
<p class="calibre3"><span class="smcap">Blackshear, Ga.</span>, Dec. 2.—In with the same men whom I deserted
on the cars. We are near the Florida line. Was put in a
passenger train at Doctortown and rode in style to this place. On
the train were two more Yanks named David and Eli S. Buck, who
are Michigan men. They were runaways who had been out in the
woods nearly three months and were in sight of our gunboats when
recaptured. Belong to the 6th Michigan Cavalry. David Buck
was one of Kilpatrick’s scouts; a very smart and brave fellow,
understands living in the woods, and thoroughly posted. We have
mutually agreed to get away the first chance, and shall get to our
lines. David Buck used to attend school at Leoni, Mich., and was
educated for a preacher. They are cousins. We three Yankees
were quite a curiosity to the passengers on the train that brought
us to this place. Some of them had evidently never seen a Yankee
before, and we were stared at for all we were worth. Some smarties
were anxious to argue the point with us in a rather “we have
got you” style. David Buck is a good talker, and satisfactorily
held up our end of the war question; in fact, I thought talked them
all out on their own grounds. The ladies in particular sneered and
stared at us. Occasionally we saw some faces which looked as if
they were Union, and we often got a kind word from some of them.
The railroads are in a broken down condition, out of decent repair,<span class="x-ebookmaker-pageno" title="[131]"><a id="Page_131"></a></span>
and trains run very slow. The Confederacy is most assuredly hard
up, and will go to pieces some of these days. My out-door life of
the few days I roamed through the woods, was just jolly. Being
out from under rebel guard made me the happiest chap imaginable.
Knew that I couldn’t escape to our lines, as I was not able to travel
much, and my sole business was to remain a tramp as long as
possible, and to get enough to eat, which I did. The negroes, and
especially the field hands, are all Union darkys, and fed me all I
wanted as a general thing. Made a mistake in going to the house
of a white woman for food.</p>
<p class="calibre3">Dec. 3.—Blackshear is an out-of-the-way place, and shouldn’t
think the Yankee army would ever find us here. The climate is
delightful. Here it is December and at the North right in the
middle of winter, and probably good sleighing, and cold; while
here it is actually warm during the day time, and at night not
uncomfortably cold. The Buck boys are jolly good fellows, and
full of fun. Seem to have taken a new lease of life myself. Both
of them are in good health and fleshy, and open for an escape any
hour. And we don’t stay here but a few days, the guards say.
Why not keep us on the cars and run us around the country all the
time? There is no wall or anything around us here, only guards.
Encamped right in the open air. Have food once a day, just whatever
they have to give us. Last night had sweet potatoes. I am
getting considerably heavier in weight, and must weigh one hundred
and forty pounds or more. Still lame, however, and I fear
permanently so. Teeth are firm in my mouth now, and can eat as
well as ever, and oh! such an appetite. Would like to see the pile
of food that I couldn’t eat. Found Rowe and Bullock, and Hub
Dakin. They are well, and all live in jolly expectancy of the next
move. The old coverlid still protects my person. The Bucks have
also each a good blanket, and we are comfortable. Some fresh
beef given us to-day; not much, but suppose all they have got.
Guard said he wished to God he was one of us prisoners instead of
guarding us.</p>
<p class="calibre3">Dec. 4.—Another delightfully cool morning. There are not a
great many guards here to watch over us, and it would be possible
for all to break away without much trouble. The men, however,
are so sure of liberty that they prefer to wait until given legitimately.
Would like to have seen this guard hold us last summer at
Andersonville. Fresh meat again to-day. Rebels go out to neighboring
plantations and take cattle, drive them here, and butcher<span class="x-ebookmaker-pageno" id="pgepubid00111" title="[132]"><a id="Page_132"></a></span>
for us to eat. Rice is also given us to eat. Have plenty of wood
to cook with. Have traded off the old missmated pair of brogans
for a smaller and good pair, and feel quite like a dandy. Have
some money to buy extras. Have plenty of food yet from that
given me at Doctortown. Divide with the Bucks, or rather, it is
all one common mess, and what any one owns belongs equally to
the others. Rebels glum, and cross, and sometimes we laugh at
them, and then they swear and tell us to shut up or they will blow
our heads off. Blackshear is a funny name and it is a funny town,
if there is any, for as yet I haven’t been able to see it. Probably a
barn and a hen-coop comprise the place. Cars go thundering by as
if the Yanks were after them. About every train loaded with
troops. Go first one way and then the other. Think they are trying
to keep out of the way themselves.</p>
<p class="calibre3">Dec. 5.—Guard said that orders were not to talk with any of the
prisoners, and above all not to let us get hold of any newspapers.
No citizens are allowed to come near us. That shows which way
the wind blows. Half a dozen got away from here last night, and
guards more strict to-day, with an increased force. Going to be
moved, it is said, in a few days. Why don’t they run us right into
the ocean? That wouldn’t do though, our gunboats are there.
Well, keep us then, that is punishment enough. Do what you are
a mind to. You dare not starve us now, for we would break away.
In fact, although under guard, we are masters of the situation.
Can see an old darky with an ox hitched to a cart with harness on,
the cart loaded with sugar cane. This is quite a sugar country, it
is said. On the road here saw the famous palmetto tree in groves.
Live-oaks are scattered all over, and are a funny affair. Persimmon
and pecan trees also abound here. We are pretty well south
now, spending the winter. But few die now; no more than would
naturally die in any camp with the same numbers. It is said that
some men get away every night, and it is probably so.</p>
<p class="calibre3">Dec. 6.—Thirteen months ago to-day captured—one year and one
month. Must be something due me from Uncle Sam in wages, by
this time. All come in a lump when it does come. No great loss
without small gain, and while I have been suffering the long imprisonment
my wages have been accumulating. Believe that we
are also entitled to ration money while in prison. Pile it on, you
can’t pay us any too much for this business. This is the land of
the blood hound. Are as common as the ordinary cur at the North.
Are a noble looking dog except when they are after you, and then<span class="x-ebookmaker-pageno" id="pgepubid00112" title="[133]"><a id="Page_133"></a></span>
they are beastly. Should think that any one of them could whip a
man; are very large, strong, and savage looking. Should think it
would be hard for the negro to run away. See no horses about
here at all—all mules and oxen, and even cows hitched up to draw
loads. I walk the prison over forty times a day. Everybody
knows me, and I hail and am hailed as I walk around, and am
asked what I think of the situation. Tell them of my escape and
the good time I had, which incites them to do likewise the first
opportunity. Occasionally a man here who growls and grumbles,
and says and thinks we will never get away, &amp;c. Some would find
fault if they were going to be hung. Should think they would
compare their condition with that of six months ago and be contented.</p>
<p class="calibre3">Dec. 7.—Another day of smiling weather. Still call our mess
the “Astor House Mess.” It is composed of only three—the Bucks
and myself. I am the only one of the original mess here, and it is
still the most prosperous and best fed of any. We are all the time
at work at something. Have a good piece of soap, and have washed
our clothing throughout, and are clean and neat for prisoners of
war. Eli S. Buck is a large fellow, and a farmer when at home.
Both are young, and from the same neighborhood. As I have said
before, are cousins, and think a great deal of one another, which is
good to see. Relatives rarely get along together in prison as well as
those who are not related. There were brothers in Andersonville
who would not mess together. Seems funny, but such is the case.
Should like to see myself throwing over a brother for any one else.
Guards denounce Jeff Davis as the author of their misfortunes.
We also denounce him as the author of ours, so we are agreed on
one point. Going to move. The “mess” will escape <i xml:lang="fr">en masse</i> at
the first move, just for the sake of roaming the woods. With the
Bucks in company with me, shall have a good time, and we can
undoubtedly soon reach our troops in as much as they are raiding
through the South. Dave Buck is the acknowledged leader of us.
He prays; think of that.</p>
<p class="calibre3">Dec. 8.—There are many men of many minds here. That used
to be a favorite copy at writing school in Jackson, Mich. “Many
men of many minds, many birds of many kinds.” How a person’s
thoughts go back to the old boyhood days in such a place as this.
Happiest times of life are those of youth, but we didn’t know it.
Everybody told us so, but we didn’t believe it; but now it is plain.
Every one, I think, has that experience. We all see where we<span class="x-ebookmaker-pageno" id="pgepubid00113" title="[134]"><a id="Page_134"></a></span>
might have done different if we only had our lives to live over, but
alas, it is not to be. A majority of the men here have about half
enough to eat. Our mess has enough to eat, thanks to our own
ingenuity. Now expect to go away from here every day. Have
borrowed a needle, begged some thread, and have been sewing up
my clothing; am well fixed up, as are also the Bucks. Am quite
handy with the needle, and it is difficult to make some of them
believe I am not a tailor by trade. If I always keep my ways mended
as I do my clothes, I shall get along very well. Eli has come
with four large yams bought of a guard and we will proceed to
cook and eat a good supper, and then go to bed and perhaps dream
of something pleasant to remember the next day. Rumors of all
kinds in camp, and rebels say something is up that will interest us,
but I can get no satisfaction as to what it is. Drew cuts for the
extra potato, and Dave won, and he cut that article of food into
three pieces and we all had a share. Good boy.</p>
<p class="calibre3">Dec. 9.—Still in Blackshear, and quiet. Many incidents happened
when I was out in the wood, and I am just crazy to get there
once more. Look at the tall trees in sight, and could hug them.
My long sickness and the terrible place in which I was confined so
long, and my recovering health, and the hope now of getting entirely
well and recovering my liberty, has made a new man of me—a
new lease of life, as it were. The Bucks are the best of fellows,
and having money which they use for my benefit the same as their
own, we get along swimmingly. One of these days my Northern
friends and relatives will hear from me. Am getting over my lameness,
and have an appetite for more than my supply of food. Certainly
had a good constitution to stand all that has been passed
through, during which time thousands and thousands died, of
apparently better health than myself. Of all my many mess-mates
and friends in prison, have lost track of them all; some died, in
fact nearly all, and the balance scattered, the Lord only knows
where. What stories we can talk over when we meet at the North.
This Blackshear country is rather a nice section. Warm and pleasant,
although rather low. Don’t know where we are located, but
must be not far from the coast.</p>
<p class="calibre3">Dec. 10.—The grand change has come and a car load of prisoners
go away from here to-day. Although the Bucks and myself
were the last in prison, we are determined to flank out and go with
the first that go. Our destination is probably Charleston, from
what I can learn. We three will escape on the road, or make a<span class="x-ebookmaker-pageno" id="pgepubid00114" title="[135]"><a id="Page_135"></a></span>
desperate effort to do so, anyway. Can walk much better now
than ten days ago, and feel equal to the emergency. Fine weather
and in good spirits, although many here are tired of being moved
from place to place. More guards have come to take charge of us
on the road, and it looks very discouraging for getting away,
although “Dave” says we will make it all right. Place great reliance
in him, as he has caution as well as the intention to escape.
So like Hendryx, and added to it has more practical quiet common
sense. Eli Buck and myself acknowledge him as leader in all
things. Now comes the tug of war.</p>
<p class="calibre3">Dec. 11.—We flanked out this morning, or rather paid three fellows
two dollars apiece for their turn to go. Are now thirty miles
from Blackshear; have been unloaded from the cars and are encamped
by the side of the railroad track for the night. Most dark.
Rebel soldiers going by on the trains, with hoots and yells. We are
strongly guarded, and it augurs not for us to get away to-night.
Our best hold is jumping from the cars. Ride on open platform
cars with guards standing and sitting on the sides, six guards to
each car. About sixty prisoners ride on each car, and there are
thirty or forty cars. Were given rations yesterday, but none to-day.
It is said we get nothing to eat to-night, which is bad; more
so for the other prisoners than ourselves. Low country we come
through, and swampy. Bucks think we may get away before
morning, but I doubt it. Rebs flying around lively, and Yanks
going for them I guess.</p>
<p class="calibre3">Dec. 12.—Routed up at an early hour and loaded on to the cars,
which stood upon a side track, and after being loaded have been
here for six mortal hours. Small rations given us just before loading
up. All are cramped up and mad. We will more than jump
the first opportunity. We go to Charleston, via Savannah. Wish
they would hurry up their old vehicles for transportation. Being
doubled up like a jack knife makes my legs stiff and sore, and difficult
to use my limbs from cramped position. Worth four hundred
dollars a day to see the rebel troops fly around. Would give something
to know the exact position now of both armies. Guards are
sleepy and tired out from doing double duty, and I think we can
get away if they move us by night, which I am afraid they won’t
do. Bucks jubilant and confident, consequently so am I.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0015.vue?ab5d8650